export const NAVIGATION_MENU_DRAWER_WIDTH = 325;
export const NAVIGATION_MENU_DRAWER_WIDTH_MOBILE = 340;
export const NAVIGATION_MENU_DRAWER_WIDTH_COLLAPSED = 90;

export const MODULE_FARM_VAULT = "vault";
export const MODULE_BUDGET = "budget";
export const MODULE_ARC_PLC = "arc_plc";
export const MODULE_INSURANCE = "insurance";
export const MODULE_FINANCIAL = "financial";
export const MODULE_REPORTS = "reports";
export const MODULE_CALCULATORS = "calculators";
export const MODULE_MARKETING = "marketing";
export const MODULE_BROKER = "broker";
export const MODULE_SYSTEM = "system";
export const MODULE_TILLEY = "tilley";
export const MODULE_POSITION_SUMMARY = "Report/Position_Summary";
export const MODULE_REVENUE_DASHBOARD = "revenue_dashboard";

export const SECTION_FINANCIAL_SCHEDULE_F = "financial/schedule_f";

export const EXPIRATION_THRESHOLD_DAYS = 30;
export const PAYMENT_TIMESTAMP_THRESHOLD_MINUTES = 1;
export const PAYMENT_SNOOZE_THRESHOLD_MINUTES = 60 * 8;
